import { render, staticRenderFns } from "./DeliverySpeedTargets.vue?vue&type=template&id=7517a44f&scoped=true"
import script from "./DeliverySpeedTargets.vue?vue&type=script&lang=js"
export * from "./DeliverySpeedTargets.vue?vue&type=script&lang=js"
import style0 from "./DeliverySpeedTargets.vue?vue&type=style&index=0&id=7517a44f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7517a44f",
  null
  
)

export default component.exports